/**
 * Message mapping for cell-member admin actions.
 *
 * Standalone on purpose: Admin.js pulls in configMgr, chart.js, the router and
 * mobx, so a test that imports the page needs all of those mocked or generated.
 * A pure string mapping should not require that, and the mapping is the part
 * worth testing.
 */

/**
 * What to show an admin when adding a cell member fails.
 *
 * A duplicate add is a normal thing to do -- an admin cannot see at a glance who
 * is already in the cell -- so the API's 409 is expected state, not a fault.
 * Before this it rendered as `Error: ServerError: [409] User is already a member`
 * and also reached Sentry through request.js's console.error, which
 * captureConsoleIntegration picks up: 28 events, 3 users, no bug behind any of
 * them (Sentry WEBAPP-26 / PLEX-3998).
 *
 * Every other status stays reported as an error. The fix is scoped to the one
 * expected conflict, not "swallow whatever this button throws".
 */
export const memberAddErrorMessage = (err, email) => {
  if (err?.status === 409) return `${email} is already a member of this cell`;
  return `Error: ${err}`;
};

export default memberAddErrorMessage;
